import styled from 'styled-components';
import { mediaQueries } from '@lce/slice';
import { SafeImage } from '../../ui/SafeImage';

export const DealImage = styled(SafeImage)`
  display: block;
  width: 96%;
  padding-top: 12px;
  max-width: 484px;

  ${mediaQueries[2]} {
    width: 100%;
    padding-top: 0px;
    max-width: 500px;
  }
`;
